module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("d2Nuu"))).then(() => parcelRequire('37nVf'));